import React from "react";
import { Box, Paper, Typography } from "@mui/material";

function Designation() {
  return (
    <Box sx={{ p: 2 }}>
      <Paper elevation={0} sx={{ p: 3, border: "1px solid #e5e7eb", borderRadius: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Designation
        </Typography>
        <Typography variant="body1" sx={{ color: "#4b5563" }}>
          This module is not implemented yet. Use Departments, Employee, or Job Openings to manage role details for now.
        </Typography>
      </Paper>
    </Box>
  );
}

export default Designation;
